import { PermissionsModules } from "../../helpers/CONSTANTS";

export const hierarchyStructure = [
  {
    id: crypto.randomUUID(),
    name: PermissionsModules.DASHBOARD,
    module: PermissionsModules.DASHBOARD,
    readView: true,
    canRead: true,
    children: [
      {
        id: crypto.randomUUID(),
        name: PermissionsModules.OPERATORS,
        module: `${PermissionsModules.DASHBOARD}/${PermissionsModules.OPERATORS}`,
        readView: true,
        canRead: true,
      },
      {
        id: crypto.randomUUID(),
        name: PermissionsModules.ROULETTES,
        module: `${PermissionsModules.DASHBOARD}/${PermissionsModules.ROULETTES}`,
        readView: true,
        canRead: true,
      }
    ]
  },
  {
    id: crypto.randomUUID(),
    name: PermissionsModules.CURRENCIES,
    module: PermissionsModules.CURRENCIES,
    readView: true,
    canRead: true,
    createView: true,
    canWrite: false,
    updateView: true,
    canUpdate: false,
    deleteView: true,
    canDelete: false,
  },
  {
    id: crypto.randomUUID(),
    name: PermissionsModules.CLIENTS,
    module: PermissionsModules.CLIENTS,
    readView: true,
    canRead: true,
    createView: true,
    canWrite: false,
    updateView: true,
    canUpdate: false,
    deleteView: true,
    canDelete: false,
    children: [
      {
        id: crypto.randomUUID(),
        name: PermissionsModules.CURRENCIES,
        module: `${PermissionsModules.CLIENTS}/${PermissionsModules.CURRENCIES}`,
        readView: true,
        canRead: true,
        createView: true,
        canWrite: false,
      },
      {
        name: PermissionsModules.GAMES,
        id: crypto.randomUUID(),
        children: [
          {
            id: crypto.randomUUID(),
            name: PermissionsModules.ROULETTES,
            module: `${PermissionsModules.CLIENTS}/${PermissionsModules.GAMES}/${PermissionsModules.ROULETTES}`,
            readView: true,
            canRead: true,
            createView: true,
            canWrite: false,
            updateView: true,
            canUpdate: false,
            deleteView: true,
            canDelete: false,
          }
        ]
      }
    ]
  },
  {
    id: crypto.randomUUID(),
    name: PermissionsModules.OPERATORS,
    module: PermissionsModules.OPERATORS,
    readView: true,
    canRead: true,
    createView: true,
    canWrite: false,
    updateView: true,
    canUpdate: false,
    deleteView: true,
    canDelete: false,
    children: [
      {
        id: crypto.randomUUID(),
        name: PermissionsModules.CURRENCIES,
        module: `${PermissionsModules.OPERATORS}/${PermissionsModules.CURRENCIES}`,
        readView: true,
        canRead: true,
        createView: true,
        canWrite: false,
      },
      {
        name: PermissionsModules.GAMES,
        id: crypto.randomUUID(),
        children: [
          {
            id: crypto.randomUUID(),
            name: PermissionsModules.ROULETTES,
            module: `${PermissionsModules.OPERATORS}/${PermissionsModules.GAMES}/${PermissionsModules.ROULETTES}`,
            readView: true,
            canRead: true,
            createView: true,
            canWrite: false,
            updateView: true,
            canUpdate: false,
            deleteView: true,
            canDelete: false,
          }
        ]
      }
    ]
  },
  {
    id: crypto.randomUUID(),
    name: PermissionsModules.PLAYERS,
    module: PermissionsModules.PLAYERS,
    readView: true,
    canRead: true,
    updateView: true,
    canUpdate: false,
    actions: [
      {
        id: crypto.randomUUID(),
        name: 'closeSession',
        module: `${PermissionsModules.PLAYERS}/closeSession`,
      }
    ]
  },
  {
    id: crypto.randomUUID(),
    name: PermissionsModules.GAMES,
    children: [
      {
        id: crypto.randomUUID(),
        name: PermissionsModules.ROULETTES,
        module: `${PermissionsModules.GAMES}/${PermissionsModules.ROULETTES}`,
        readView: true,
        canRead: true,
        createView: true,
        canWrite: false,
        updateView: true,
        canUpdate: false,
        deleteView: true,
        canDelete: false,
      }
    ]
  },
  {
    id: crypto.randomUUID(),
    name: PermissionsModules.USERS,
    module: PermissionsModules.USERS,
    readView: true,
    canRead: true,
    createView: true,
    canWrite: false,
    updateView: true,
    canUpdate: false,
    deleteView: true,
    canDelete: false,
  }
]